import { render } from "./PollAudienceForm.vue?vue&type=template&id=396a204e&scoped=true"
import script from "./PollAudienceForm.vue?vue&type=script&lang=js"
export * from "./PollAudienceForm.vue?vue&type=script&lang=js"

import "./PollAudienceForm.vue?vue&type=style&index=0&id=396a204e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-396a204e"]])

export default __exports__